module.exports = __webpack_public_path__ + "img/39.like.1bb10522.svg";